<div class="quiz">
    <quiz-question
     *ngFor="let question of questions"
     [question]="question"
     [locked]="submited || timeout"
     (select)="registerAnswer($event)"
    ></quiz-question>
    
    <button (click)="onSubmit()" [disabled]="submited || timeout">Submit</button>

    <p class="quiz__results" *ngIf="result !== null">
        Você acertou {{ result }} de {{ questions.length }} perguntas.
    </p>
</div>
